import React, { Component }                 from 'react';
import ReactTable                           from 'react-table';
import urlHandler                           from '../../utils/urlHandler';
import settings                             from '../../utils/settings';
import perms                                from '../../utils/permissions';
import KbInfoControl                        from '../knowledgebase/KbInfoControl';
import KbQueryControl                       from '../knowledgebase/KbQueryControl';
import KbEntityDataControl                  from '../knowledgebase/KbEntityDataControl';
import KbGeoDataControl                     from '../knowledgebase/KbGeoDataControl';
import { kbEditOrganizationDialog }         from './KbEditOrganizationDialog';
import { kbEditPersonDialog }               from './KbEditPersonDialog';
import { kbEditThingDialog }                from './KbEditThingDialog';
import KbCreatePersonDialog                 from './KbCreatePersonDialog';
import KbCreateOrganizationDialog           from './KbCreateOrganizationDialog';
import KbCreateThingDialog                  from './KbCreateThingDialog';
import { kbDeleteDialog }                   from './KbDeleteDialog';
import UserManual                           from '../../styles/docs/FFT_DemoUserGuide.pdf';
import history                              from '../../utils/history';

import 'react-table/react-table.css'

class KnowledgebaseControl extends Component {
    constructor(props){
        super(props);

        this.onSelectResult = this.onSelectResult.bind(this);
        this.onResultsChange = this.onResultsChange.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onCreate = this.onCreate.bind(this);
        this.onCreateCompleted = this.onCreateCompleted.bind(this);
        this.onDelete = this.onDelete.bind(this);

        this.state = {
            kbPermissions: {
                search: false,
                read: false,
                update: false,
                create: false,
                delete: false,
                locationfinder: false
            },
            kbs: null,
            selected: null,
            selectedData: null,
            selectedType:'',
            results: null,
            lfResults: null,
            createPerson: false,
            createOrg: false,
            createThing: false
        }

        this.externalUrlsDisable = window._externalUrlsDisable;
    }

    componentDidMount() {
        const kbPermissions = {
            search: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntitySearch']),
            read: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityRead']),
            update: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityUpdate']),
            create: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityCreate']),
            delete: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityDelete']),
            locationfinder: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_LOCATION_FINDER),
            kbQuery: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_KB_QUERY)
        }

        if (!kbPermissions.search && !kbPermissions.read){
            history.push('/')
        } else if (kbPermissions.search) {
            urlHandler.sendKbInfoRequest(null, (resp, status) => {
                if (status == 200) {
                    this.setState({
                        kbPermissions,
                        kbs: resp.collections.filter((collection) => ['PEOPLE','ORGANIZATIONS','THINGS'].indexOf(collection.name) != -1)
                    });
                } else {
                    console.log('Error calling sendKbInfoRequest => ', resp);     
                    this.setState({kbPermissions});        
                }
            });            
        } else {
            this.setState({kbPermissions});
        }
    }

    onSelectResult(state, rowInfo, column, instance) {
        if (rowInfo) {
            if (rowInfo.index === this.state.selected) {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original,
                            selectedType: rowInfo.original.document.type
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        background: '#E9ECE0',
                        cursor: 'pointer'
                    }
                };
            } else {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original,
                            selectedType: rowInfo.original.document.type
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        cursor: 'pointer'
                    }
                };                
            }
    
        } else {
            return {}
        }
    }

    onResultsChange(data) {
        if (data && 'results' in data) {
            // Had to set state twice in order to get the ReactTable to see data changes and force rerender
            this.setState({
                results: [],
                lfResults: []
            },() => {
                this.setState({
                    results: [ ...data.results ],
                    selectedData: null,
                    selected: -1,
                    selectedType: ''
                })
            })                
        } else if (data && 'enclosingViewBounds' in data && 'locations' in data) {
            // Had to set state twice in order to get the ReactTable to see data changes and force rerender
            this.setState({
                results: [],
                lfResults: []
            },() => {
                this.setState({
                    lfResults: [ ...data.locations ],
                    selectedData: null,
                    selected: -1,
                    selectedType:''
                })
            })                
        } else {
            this.setState({
                results: [],
                lfResults: []
            })
        }
    }

    onEdit(entity) {
        if (entity) {

            // Update the edited entity in the current search results
            this.state.results.map((result)=> {
                var doc = result.document;
                if (doc.id == entity.id) {
                    doc.description = entity.description;
                    doc.label = entity.label;
                    doc.urls = entity.urls;
                }
            });

            this.setState({
                selectedData: null,
                selected: -1
            }) 
        }
    }

    onCreate(e) {
        e.stopPropagation();
        var type = this.refs.kbCreateType ? this.refs.kbCreateType.value : null;
        this.setState({
            createPerson: type === 'PERSON' ? true : false,
            createOrg: type === 'ORGANIZATION' ? true : false,
            createThing: type === 'THING' ? true : false
        })
    }

    onCreateCompleted() {
        this.setState({
            createPerson: false,
            createOrg: false,
            createThing: false
        })
    }

    onDelete(id) {
        if (id) {

            // Remove entity in the current search results
            const updated = this.state.results.filter((result) => {
                var doc = result.document;
                if (doc.id == id) {
                    return false;
                }
                return true;
            })

            this.setState({
                selectedData: null,
                selected: -1,
                results: updated
            }) 
        }
    }

    onClickUrl(url, e) {
        var win = window.open(url, '_blank');
        win.focus();
        e.stopPropagation();
    }

    render() {    

        const columns = [{
            Header: 'Actions',
            width: 75,
            accessor: 'document.id', Cell: (row) => (
                <span>
                    {this.state.kbPermissions.update && row.original.document.type === 'ORGANIZATION' &&
                        <span className="fa fa-edit kbedit-invoke-link" title="Edit organization" onClick={() => {
                            kbEditOrganizationDialog(row.original.document.label, row.original.document.id, this.onEdit);
                        }}/>
                    }
                    {this.state.kbPermissions.update && row.original.document.type === 'PERSON' &&
                        <span className="fa fa-edit kbedit-invoke-link" title="Edit person" onClick={() => {
                            kbEditPersonDialog(row.original.document.label, row.original.document.id, this.onEdit);
                        }}/>
                    }
                    {this.state.kbPermissions.update && !(row.original.document.type === 'ORGANIZATION' || row.original.document.type === 'PERSON') &&
                        <span className="fa fa-edit kbedit-invoke-link" title="Edit thing" onClick={() => {
                            kbEditThingDialog(row.original.document.label, row.original.document.id, this.onEdit);
                        }}/>
                    }
                    {this.state.kbPermissions.delete &&
                        <span className="fa fa-trash-o kbedit-invoke-link" title="Delete entity" onClick={() => {
                            kbDeleteDialog(row.original.document.type, row.original.document.label, row.original.document.id, this.onDelete);
                        }}/>
                    }
                </span>
            ),
            show: this.state.kbPermissions.update || this.state.kbPermissions.delete
        }, {
            Header: 'Score',
            accessor: 'score', Cell: (row) => (
                <div>
                {row.original.score && 
                    row.original.score.toFixed(4)
                }
                </div>
            ),
            width: 100
        }, {
            Header: 'Id',
            accessor: 'document.id',
            width: 175
        }, {
            Header: 'Label',
            accessor: 'document.label'
        }, {
            Header: 'Urls',
            accessor: 'document.urls', Cell: (row) => (
                <div>
                {(row.original.document.urls && row.original.document.urls.length > 0) ?
                    <div>
                        {row.original.document.urls.slice(0, 5).map((url, index) => {
                            if (this.externalUrlsDisable) {
                                return <div key={index}>{url}</div>
                            } else {
                                return <div key={index} onClick={this.onClickUrl.bind(this, url)} className="kbcontrol-link">{url}</div>
                            }
                        })}
                    </div>
                :
                    <div></div>
                }
                </div>
            ),
            show: !this.state.selectedData
        }];

        const lfColumns = [{
            Header: 'Id',
            accessor: 'id',
            width: 175
        }, {
            Header: 'Label',
            accessor: 'label'
        }, {
            Header: 'Feature',
            accessor: 'dsgFeatureCodeLabel',
            width: 175
        },{
            Header: 'Admin1 Label',
            accessor: 'admin1Label',
            width: 175
        },{
            Header: 'Admin2 Label',
            accessor: 'admin2Label',
            width: 200,
            show: !this.state.selectedData
        },{
            Header: 'Country',
            accessor: 'countryLabel'
        }];

        return (
            <div className='kbcontrol-wrapper'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <span>
                                    <h1 className='heading-1' style={{float: 'left', marginBottom: '25px'}}>Knowledgebase</h1>
                                    <span style={{float: 'right'}}>
                                        <a href={ UserManual } target="__blank" download="FFT_DemoUserManual.pdf"> 
                                            <span className='fa fa-file-pdf-o'>&nbsp;</span> 
                                            User Manual 
                                        </a> 
                                    </span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {this.state.kbPermissions.search &&
                                    <KbInfoControl kbs={this.state.kbs}/>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{width: '100%'}}>
                                                <KbQueryControl permissions={this.state.kbPermissions}
                                                    onChange={this.onResultsChange}
                                                    kbs={this.state.kbs}/>
                                            </td>
                                            {this.state.kbPermissions.create &&
                                                <td className="kbcontrol-create-wrapper">
                                                    <button type="button" 
                                                        className="kbcontrol-primary-button create-button" 
                                                        onClick={this.onCreate}>Create New
                                                    </button>
                                                    <span className="form-field-wrapper text-field">
                                                        <select className='form-field create-selection' ref='kbCreateType'>
                                                            <option value="PERSON">PERSON</option>
                                                            <option value="ORGANIZATION">ORGANIZATION</option>
                                                            <option value="THING">THING</option>
                                                        </select>
                                                    </span>
                                                    <KbCreatePersonDialog show={this.state.createPerson} onCreate={this.onCreateCompleted}/>
                                                    <KbCreateOrganizationDialog show={this.state.createOrg} onCreate={this.onCreateCompleted}/>
                                                    <KbCreateThingDialog show={this.state.createThing} onCreate={this.onCreateCompleted}/>
                                                </td>
                                            }
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {(this.state.results && this.state.results.length > 0) &&
                    <div className="kbcontrol-results">
                        <span className="kbcontrol-list">
                            <span>{this.state.results.length} results found.</span>
                            <ReactTable className="kb-table -striped"
                                data={this.state.results} 
                                columns={columns}
                                showPagination={false}
                                minRows={0}
                                defaultPageSize={this.state.results.length}
                                getTdProps={this.onSelectResult}/>
                        </span>

                        {this.state.selectedData &&
                            <div>
                                <div className="kbcontrol-details-static">
                                    <KbEntityDataControl
                                        permissions={this.state.kbPermissions} 
                                        selectedData={this.state.selectedData}/>
                                </div>
                            </div>
                        }
                    </div>
                }
               {(this.state.lfResults && this.state.lfResults.length > 0) &&
                    <div className="kbcontrol-results">
                        <span className="kbcontrol-list">
                            <span>{this.state.lfResults.length} locations found.</span>
                            <ReactTable className="kb-table -striped"
                                data={this.state.lfResults} 
                                columns={lfColumns}
                                showPagination={false}
                                minRows={0}
                                defaultPageSize={this.state.lfResults.length}
                                getTdProps={this.onSelectResult}/>
                        </span>

                        {this.state.selectedData &&
                            <div>
                                <div className="kbcontrol-details-static">
                                    <KbGeoDataControl data={this.state.selectedData}/>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default KnowledgebaseControl;
